import React, { useEffect, useState } from "react";
import { confirmable } from "react-confirm";
import {
  message,
  Modal,
  Col,
  Input,
  Row,
  Tooltip,
  Radio,
  Spin,
  DatePicker,
  Checkbox,
} from "antd";

import "./SeparatePrintDialog.css";
import { isEmpty } from "utils/GlobalFunctions";
import moment from "moment";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import ProductInputNumber from "components/InputWidgets/InputNumber/ProductInputNumber";
import ProductDescriptionInput from "components/ProductPage/ProductDescriptionInput/ProductDescriptionInput";
import RecipeExtraItems from "../../RecipeExtraItems/RecipeExtraItems";
import ExtraOptionItems from "../../ExtraOptionItems/ExtraOptionItems";
import ProductTypeSelector from "components/ProductPage/ProductTypeSelector/ProductTypeSelector";

function SeparatePrintDialog(props) {
  const { show, proceed, info, title, customer_name } = props;

  const [data, setData] = useState({});
  const [errorField, setErrorField] = useState([]);
  const [isBusy, setIsBusy] = useState(false);
  const randomId = `ID_${Math.random().toString(36).substring(2, 6)}`;
  const [newUnit, setNewUnit] = useState({ name: customer_name, price: 0, paid_amount: 0 });
  const [selectedPrintList, setSelectedPrintList] = useState([]);

  var groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };
  useEffect(() => {}, []);

  useEffect(() => {}, [info]);

  const validateFields = async () => {
    if (selectedPrintList.length === 0) {
      message.info("Select Order");
      return false;
    }
    var errorList = Array();
    errorList = isEmpty(newUnit, "name", errorList);
    setErrorField([...errorList]);
    return errorList.length == 0;
  };
  const onChange = (e, item) => {
    const checked = e.target.checked;
    let tmpList = selectedPrintList;
    let index = tmpList.findIndex((e) => e.id === item.id);
    if (checked) {
      if (index === -1) {
        tmpList.push(item);
      }
    } else {
      if (index !== -1) {
        tmpList.splice(index, 1);
      }
    }
    var sum = 0;
    tmpList.forEach(e => {
      sum += parseFloat(e['total_price']);
    });
    let info = newUnit;
    info['price'] = sum;
    setNewUnit({ ...info });

    setSelectedPrintList(tmpList);
  };
  const itemUI =
    info.cartList == undefined || info.cartList.length == 0 ? (
      <div>You don't have any Item list</div>
    ) : (
      info.cartList.map((item, index) => {
        return (
          <div key={index}>
            <div style={{ display: "flex", alignItems: "flex-start" }}>
              <div style={{ marginLeft: 4, marginRight: 12 }}>
                <Checkbox
                  onChange={(e) => onChange(e, item)} // ✅ pass item + index
                />
              </div>

              <div
                style={{
                  backgroundColor: item.fill_color,
                  color: "white",
                  padding: 5,
                  marginTop: 3,
                  flex: 1, // take remaining width
                }}
              >
                <Row gutter={4}>
                  <Col>
                    <span className="bold font-14">{item.enter_qty}x</span>
                  </Col>
                  <Col>
                    <div className="item-name bold font-14">{item.name}</div>
                    <div className="font-15">
                      ${parseFloat(item.total_price).toFixed(2)}&nbsp;
                      {info.payment_currency}
                    </div>
                  </Col>
                </Row>

                <div>
                  <RecipeExtraItems optionItemString={item.recipe_extra} />
                </div>

                <div>
                  <ExtraOptionItems optionItemString={item.extraOptionList} />
                </div>

                <div className="item-note font-14">{item.note}</div>
              </div>
            </div>

            {info.cartList.length != index + 1 && (
              <div className="item-body-bottom"></div>
            )}
          </div>
        );
      })
    );

  return (
    <Modal
      open={show}
      destroyOnClose={true}
      onCancel={() => {
        proceed(null);
      }}
      closable={true}
      maskClosable={false}
      title={title}
      className="custom-separate-print-dlg"
      onOk={async () => {
        if ((await validateFields()) === false) return;

        proceed({
          selectedPrintList: selectedPrintList,
          customer_name: newUnit.name,
        });
      }}
    >
      <Spin spinning={isBusy}>
        <Row gutter={[8, 8]}>
          <Col xs={24} sm={8} md={8} lg={8} xl={8}>
            <div>Name(ID)*</div>
            <ProductDescriptionInput
              placeholder="Customer Name"
              field={"name"}
              productInfo={newUnit}
              setProductInfo={setNewUnit}
              errorField={errorField}
              setErrorField={setErrorField}
            />
          </Col>
          
          <Col xs={24} sm={4} md={4} lg={4} xl={4}>
            <div>Cost</div>
            <div style={{padding:8}}>${newUnit["price"]}</div>
          </Col>
          <Col xs={24} sm={8} md={8} lg={8} xl={8}>
            <div>Paid Amount</div>
            <ProductInputNumber
              field={"paid_amount"}
              productInfo={newUnit}
              setProductInfo={setNewUnit}
              errorField={errorField}
              setErrorField={setErrorField}
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
            />
          </Col>
          <Col xs={24} sm={4} md={4} lg={4} xl={4}>
            <div>Rest</div>
            <div style={{padding:8}}>${newUnit["paid_amount"] - newUnit["price"]}</div>
          </Col>
        </Row>
        <div className="item-separate-print-body">{itemUI}</div>
      </Spin>
    </Modal>
  );
}

export default confirmable(SeparatePrintDialog);
